/*
  Hacky temporary function to convert different bathroom representations
  (e.g. 2.1, 2.2, 2.25, 2.5, 2.75) to an easier to understand standard.
  This function preserves half bathrooms that are inputted as 0.5,
  rounds quarter bathrooms from 0.25 to 0.5, rounds three quarter bathrooms
  from 0.75 to 1, and converts half bathrooms from 0.1 to 0.5.

  Long term fix is to sanitize and standardize the data that we ingest
  from seller inputs and MLS into a common format on the backend.
*/
export default function standardizeBathroomCounts(bathrooms) {
  let fullBaths = Math.floor(bathrooms);
  let partialBaths = +(bathrooms - fullBaths).toFixed(2);
  let additionalBaths = 0;
  switch (partialBaths) {
    case 0.25:
    case 0.5:
      additionalBaths = 0.5;
      break;
    case 0.75:
      additionalBaths = 1;
      break;
    default:
      additionalBaths = partialBaths * 5;
  }
  return +(fullBaths + additionalBaths).toFixed(2);
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/helpers/standardize-bathroom-count.js
 **/